<template>
<div class="membership-box">

</div>
</template>

<script>
export default {
  methods: {
    becomeAMember($e) {
      $e.preventDefault();
      if (!appRoot.loggedIn) {
        $("html,body").animate({scrollTop: 0}, 300);
        appHeadNav.currentPane='register';
      }
      else
        this.$router.push("/packages");
    },
  },
}
</script>
